/**
 * MorningReport callables (functions/src/morningReport). Answer keys never
 * reach the client; these return grades, counts and generated content only.
 */
import { getFunctions, httpsCallable } from "firebase/functions";

export const isDailyLimitError = (err) => err?.details?.reason === "daily_limit";

// Any model call can hit the daily limit. The open page listens here so it can
// say so once, in one place, instead of as an error on whichever step hit it.
const dailyLimitListeners = new Set();

export function onDailyLimit(listener) {
  dailyLimitListeners.add(listener);
  return () => dailyLimitListeners.delete(listener);
}

const call = (name, options) => {
  const fn = httpsCallable(getFunctions(), name, options);
  return async (payload = {}) => {
    try {
      return (await fn(payload)).data;
    } catch (err) {
      if (isDailyLimitError(err)) dailyLimitListeners.forEach((listener) => listener(err.message));
      throw err;
    }
  };
};

export const startMorningReportCase = call("startMorningReportCase");
export const getMorningReportAccess = call("getMorningReportAccess");
export const getSlotCount = call("getMorningReportSlotCount");
export const gradeBoard = call("gradeMorningReportBoard");
export const coachBoard = call("coachMorningReportBoard");
export const gradeFinalDiagnosis = call("gradeMorningReportFinalDiagnosis");
export const readDiagnosticKey = call("readMorningReportDiagnosticKey");
export const generateDiagnostics = call("generateMorningReportDiagnostics");
export const generateTreatment = call("generateMorningReportTreatment");
export const generatePearls = call("generateMorningReportPearls");
export const createCheckout = call("createMorningReportCheckout");
export const createPortal = call("createMorningReportPortal");
export const confirmCheckout = call("confirmMorningReportCheckout");

// Case maker (platform admins). A draft is three model calls, and saving a
// script change to a live case waits for the new lines' audio, so these wait longer.
const LONG_CALL = { timeout: 300000 };
export const draftCase = call("draftMorningReportCase", LONG_CALL);
export const getCaseDraft = call("getMorningReportCaseDraft");
export const saveCase = call("saveMorningReportCase", LONG_CALL);
export const remakeCaseSuggestions = call("remakeMorningReportCaseSuggestions", LONG_CALL);
export const setCaseStatus = call("setMorningReportCaseStatus");
export const deleteCaseDraft = call("deleteMorningReportCaseDraft");
export const moveQueuedCase = call("moveMorningReportQueuedCase");
